// @ts-nocheck

import cx from 'classnames';
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import controller from './controller';
import ListingEngineActions from 'app/shared/flux/actions/ListingEngineActions';
import AppActions from 'app/shared/flux/actions/AppActions';
import Linker from 'app/shared/modules/Linker';
import { css } from '@/styled-system/css';

const activePagerItemStyle = css({
  fontWeight: 'bold',
});

class PagerItem extends React.Component {
  static defaultProps = {
    linkType: 'accent',
    className: '',
    query: {},
    url: '',
  };
  constructor(props) {
    super(props);
  }

  render() {
    const { className, children, maxPage, currPage, page, query, url, linkType, dispatch } = this.props;

    const isEdgePage = controller.isEdgePage(page, maxPage);
    const isInvalidPage = controller.isInvalidPage(page, maxPage);

    if (isEdgePage) {
      return (
        <Linker className={cx('PagerItem', className)} key={'page' + page} linkType="accent-light" disabled to="#">
          {children}
        </Linker>
      );
    }

    if (isInvalidPage) {
      return null;
    }

    if (currPage === page) {
      return (
        <div className={cx(className, activePagerItemStyle)} key={'page' + page} aria-current="page">
          {children}
        </div>
      );
    }

    const linkTo = controller.makeLink(page, query, url);

    return (
      <div className={cx('PagerItem', className)}>
        <Linker
          key={'page' + page}
          onClick={(e) => {
            dispatch(AppActions.setAppStoreBool('fetchListingsByCoordsComplete', false));
            dispatch(ListingEngineActions.clearCache());
          }}
          to={linkTo}
          linkType={linkType}
        >
          {children}
        </Linker>
      </div>
    );
  }
}

PagerItem.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  maxPage: PropTypes.number.isRequired,
  currPage: PropTypes.number.isRequired,
  page: PropTypes.number.isRequired,
  query: PropTypes.object,
  url: PropTypes.string,
  linkType: PropTypes.string,
  dispatch: PropTypes.func.isRequired,
};

export default connect()(PagerItem);
